import formatters from './formatters';

export const MAX_COLUMN_WIDTH = 1000;
export const MIN_COLUMN_WIDTH = 50;
export const LOCAL_STORAGE_COLUMNS_KEY = 'AUDIT_TRAIL_COLUMNS';

export const AUDIT_TRAIL_COLUMNS = {
  icon: {
    isVisible: true,
    width: 30,
    formatter: formatters.icon,
  },
  eventType: {
    clickable: false,
    resizable: true,
    sortable: true,
    width: 200,
    isVisible: true,
  },
  timeStamp: {
    clickable: false,
    formatter: formatters.createdDate,
    resizable: true,
    sortable: true,
    width: 150,
    isVisible: true,
  },
  userName: {
    clickable: false,
    resizable: true,
    sortable: true,
    width: 150,
    isVisible: true,
  },
  description: {
    clickable: false,
    resizable: true,
    sortable: true,
    width: 500,
    isVisible: true,
  },
  comment: {
    clickable: false,
    resizable: true,
    sortable: true,
    width: 500,
    isVisible: true,
  },
  reason: {
    clickable: false,
    resizable: true,
    sortable: true,
    width: 160,
    isVisible: true,
  },
};



// WEBPACK FOOTER //
// ./src/components/AuditTrailPanel/constants.js